/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
import { makeStyles } from "@material-ui/styles";
import { AppBar, Toolbar, Badge, Hidden, IconButton, Button, Typography } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
// import NotificationsIcon from "@material-ui/icons/NotificationsOutlined";
// import InputIcon from "@material-ui/icons/Input";
import logo from "images/Adveni.jpg";
import noAiLogo from "images/AdvenioTel.jpg"
import "./Topbar.css";
// common util
// import { getTimeDateInFormate, getTimeAgo } from "common/common-util-functions";

// actions
import { getNetSpeed } from "actions/global-action";
import { syncPatientDataWithServer } from "actions/patient-action";
// import patientHistory from "views/add-patient/components/patient-history";
import {
  getuserDetailNew,
  updateOrgCountsAndBalances,
} from "actions/user-action";
import EntitlementProjectionSummary from "realtime/EntitlementProjectionSummary";
// sync url
// import { baseURL, syncBaseUrl } from "database/onlineDb/baseUrl";
// //offlinedb
// import { updatePatientID, deletePatient } from "database/offlineDb/indexDb";
// import {
//  getFirstNameOfCurrentUserFromSessionStorage,
//  getAuthenticationDetailsFromSessionStorage,
//  getAuthTokenFromSessionStorage,
// } from "helpers/common";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow:
      "0 0px 0px 0 rgba(0, 0, 0, 0.2), 0 4px 4px 0 rgba(0, 0, 0, 0.19)",
  },
  flexGrow: {
    flexGrow: 1,
  },
  MenuIcon: {
    color: "#f77200",
  },
  logo: {
    marginLeft: "5px",
    width: "150px",
    [theme.breakpoints.down("sm")]: {
      width: "120px",
      marginTop: "1px",
      marginRight: "5px",
    },
  },
  signOutButton: {
    marginLeft: theme.spacing(1),
    fontSize: "1rem",
  },
  Toolbar: {
    background: "white",
    paddingLeft: "10px",
  },
  tradeMark: {
    fontSize: "9px",
    verticalAlign: "top",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "1px",
    },
  },
  processCount: {
    margin: "auto",
  },
  colorIndicator: {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    margin: "5px",
  },
  goodBalanceStatus: {
    backgroundColor: "green",
  },
  averageBalanceStatus: {
    backgroundColor: "yellow",
  },
  lowBalanceStatus: {
    backgroundColor: "red",
  },
}));

const Topbar = (props) => {
  const {
    className,
    onSidebarOpen,
    onSidebarMini,
    isViewPatientsBuActive,
    isBulkUploadForPatientActive,
    lastRechargedPrice,
    currentUserOrgzBalanceAmount,
    ...rest
  } = props;
  const classes = useStyles();
  const [cookies, setCookie] = useCookies();
  const [netState, setNetState] = React.useState("");
  const [notifications] = useState([]);
  const [reportsGenerated, setReportsGenerated] = useState("loading");
  const noAiAnnotation=props?.userStore?.userProfile?.no_ai_annotation

  // Derive pro-bono active state from quota + expiry (no DB column — dropped).
  const bal = props.userStore?.imageProcessAndBalanceAmount;
  const entitlement = props.entitlementStore?.projection;
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const isProBonoActive =
    bal?.free_no_of_images > (bal?.actual_fnoi || 0) &&
    bal?.valid_till &&
    startOfDay(new Date(bal.valid_till)) >= startOfDay(new Date());

  //  React.useEffect(() => {
  //   let tempArr = [];
  //   let patientsList =
  //    props.patientStore.patientsList !== undefined
  //     ? props.patientStore.patientsList
  //     : [];
  //   if (
  //    props.globalStore.speedData !== undefined &&
  //    props.globalStore.speedData.downlink >= 1
  //   ) {
  //    // patientsList.map(user=>{
  //    //   if(user.regDate!==undefined){
  //    //     let regData=getRegTimeFromNow(user.regDate)
  //    //     if(regData>=1){
  //    //       handleSyncWithServer(user)
  //    //     }
  //    //   }
  //    // })
  //    tempArr = patientsList.filter(
  //     (user) => getRegTimeFromNow(user.regDate) >= 1
  //    );
  //    // handleSyncWithServer(tempArr)
  //   }
  //  }, [props.patientStore]);

  useEffect(() => {
    const getNecessaryCountsAndBalances = async () => {
      if (!props.userStore?.imageProcessAndBalanceAmount?.balance_amount) {
        props.updateOrgCountsAndBalances();
      }
    };

    getNecessaryCountsAndBalances();
  }, [
    props.userStore?.userProfile,
    Boolean(props.userStore?.imageProcessAndBalanceAmount?.balance_amount),
  ]);

  //  const getRegTimeFromNow = (regDate) => {
  //   // console.log('aaa',((new Date()-regDate )/ (1000 * 60 * 60)).toFixed(1))
  //   if (regDate !== undefined) {
  //    //convert millisec to hours
  //    // const timeAgo=(new Date()-regDate )/(1000 * 60*60)
  //    // for minute
  //    const timeAgo = (new Date() - regDate) / (1000 * 60 * 60 * 24);
  //    //
  //    return timeAgo;
  //   } else {
  //    return 0;
  //   }
  //  };
  //  function handleSyncWithServer(user) {
  //   let tempArr = [];
  //   user.map((item) => {
  //    // console.log('handleSyncWithServer',item)
  //    // tempArr.push({mrn:item.mrn,...item.registrationData,...props.globalStore.userAgentData.ua__summary})
  //    if (!item.isRegOnServer) {
  //     axios({
  //      method: "post",
  //      url: syncBaseUrl + "/patient",
  //      data: {
  //       mrn: item.mrn,
  //       ...item.registrationData,
  //       ...props.globalStore.userAgentData.ua__summary,
  //      },
  //      headers: {
  //       Accept: "*/*",
  //       authorization: getAuthTokenFromSessionStorage(),
  //      },
  //     }).then((res) => {
  //      let data = {
  //       isRegOnServer: true,
  //       ...item,
  //      };
  //      updatePatientID(res.data, data).then((res) => {
  //       // console.log('resss2',res)
  //       deletePatient(item.mrn);
  //      });
  //     });
  //    }
  //   });

  //   // console.log('handleSyncWithServer',tempArr)
  //   // props.syncPatientDataWithServer(tempArr)
  //  }
  // Showing Online and Offline is not required as of now(Ms.Amruta)
  // const getConnectionData = (speed) => {
  //   if (navigator.onLine) {
  //     return (
  //       <>
  //         <p
  //           className="online"
  //           style={{
  //             color: "green",
  //             fontSize: "14px",
  //             fontFamily: "Montserrat, sans-serif",
  //           }}
  //         >
  //           Online
  //         </p>
  //       </>
  //     );
  //   }
  //   // else if(speed<1&&speed>0&&navigator.onLine){
  //   //   return <p style={{color:"#f77200"}}>Offline(Poor Network)</p>
  //   // }
  //   else if (navigator.onLine === false) {
  //     return (
  //       <p
  //         className="online"
  //         style={{
  //           color: "red",
  //           fontSize: "14px",
  //           fontFamily: "Montserrat, sans-serif",
  //         }}
  //       >
  //         Offline
  //       </p>
  //     );
  //   }
  //   // return "Online"
  // };

  const countBalancesAndOtherStatsGen = () => {
    const locationHref = window.location.href;
    const entitlementAvailable = entitlement?.paid?.available;
    const entitlementTotal = entitlement?.paid?.total;
    const remainingBalance = entitlementAvailable && entitlementTotal
      ? Number(entitlementAvailable) / Number(entitlementTotal)
      : currentUserOrgzBalanceAmount / lastRechargedPrice;
    const remainingBalanceStatusColor =
      remainingBalance > 0.5
        ? "goodBalanceStatus"
        : remainingBalance > 0.25
        ? "averageBalanceStatus"
        : "lowBalanceStatus";
    const formattedOrgzBalanceAmount = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR", // Use symbol as currency display
      minimumFractionDigits: 2,
    }).format(currentUserOrgzBalanceAmount);
    const validTillDateFormater = (inputDateString) => {
      const inputDate = new Date(inputDateString);

      const day = String(inputDate.getUTCDate()).padStart(2, "0");
      const month = String(inputDate.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = inputDate.getUTCFullYear();

      const formattedDate = `${day}/${month}/${year}`;
      return formattedDate
    };

    return (
      <>
        {(locationHref.includes("patients") ||
          locationHref.includes("view-patients") ||
          locationHref.includes("bulk-upload") ||
          locationHref.includes("view-images") ||
          locationHref.includes("view-patients-bu")) && (
          <>
            <Hidden only={["xs"]}>
              <EntitlementProjectionSummary />
              <div>
                &nbsp;
                <span className={classes.countText}>
                  {isProBonoActive
                    ? "Pro-Bono"
                    : isBulkUploadForPatientActive &&
                    (locationHref.includes("bulk-upload") ||
                      locationHref.includes("view-patients-bu"))
                    ? "Patients"
                    : "Patients"}
                  &nbsp;Processed&nbsp;:&nbsp;
                </span>
              </div>
            </Hidden>
            {
              isProBonoActive
                ? props.userStore?.imageProcessAndBalanceAmount?.actual_fnoi || 0
                : props.userStore?.imageProcessAndBalanceAmount?.[
                  locationHref.includes("view-patients-bu")
                    ? "patient_bu_count"
                    : locationHref.includes("view-patients") ||
                      locationHref.includes("patients")
                    ? "total_patients"
                    : locationHref.includes("bulk-upload") &&
                      isBulkUploadForPatientActive
                    ? "patient_bu_count"
                    : "bulk_img_count"
                ]
            }{" "}
            |{" "}
            {
              // props.userStore?.imageProcessAndBalanceAmount?.[
              //   locationHref.includes("view-patients-bu")
              //     ? "pat_bu_img_total_count"
              //     : locationHref.includes("view-patients") ||
              //       locationHref.includes("patients")
              //     ? "pat_img_total_count"
              //     : locationHref.includes("bulk-upload") &&
              //       isBulkUploadForPatientActive
              //     ? "pat_bu_img_total_count"
              //     : "bulk_img_total_count"
              // ]
              <div
                className={`${classes.colorIndicator} ${classes[remainingBalanceStatusColor]}`}
                title={
                  remainingBalanceStatusColor === "goodBalanceStatus"
                    ? "Balance > 50% of last recharged amount."
                    : remainingBalanceStatusColor === "averageBalanceStatus"
                    ? "Balance is between 25% and 50% of last recharged amount."
                    : remainingBalanceStatusColor === "lowBalanceStatus"
                    ? "Balance is below 25% of last recharged amount."
                    : ""
                }
              ></div>
            }
            {isProBonoActive && <div style={{ marginLeft: "min(7em, 10vw)" }}>
                Valid Till :{" "}
                {props.userStore?.imageProcessAndBalanceAmount?.valid_till
                  ? validTillDateFormater(props.userStore?.imageProcessAndBalanceAmount?.valid_till)
                  : "NA"}
              </div>}
          </>
        )}
      </>
    );
  };

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar className={classes.Toolbar}>
        <Hidden smDown>
          <IconButton
            className={classes.MenuIcon}
            onClick={onSidebarMini}
            size="medium"
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden mdUp>
          <IconButton className={classes.MenuIcon} onClick={onSidebarOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/">
          <img
            alt="Logo"
            src={noAiAnnotation===1?noAiLogo:logo}
            // width="200"
            className={classes.logo}
          />
          <span className={classes.tradeMark}>
            <b>TM</b>
          </span>
        </RouterLink>
        {/* Commented the flex grow div and gave process-count-display-container  "margin:auto". Author:Sai */}
        {/* <div className={classes.flexGrow} /> */}
        {/* <Hidden smDown> */}
        {/* <IconButton>
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
        <div className="process-count-display-container">
          {countBalancesAndOtherStatsGen()}
        </div>
        {/* Commneted the wrapper button upon request of Ms.Amrutha, author:Sai */}
        {/* 
        <IconButton
          className={classes.signOutButton}
          // color="inherit"
        > */}
        {/* <InputIcon /> */}
        {isProBonoActive &&<Typography variant="h4" style={{ color: 'red',marginTop: '5px' }} gutterBottom>
        (Pro-Bono) :
      </Typography>}
      {"  "}
            |{"  "}
        <h4
          className="username"
          style={{
            color: "black",
            marginRight: "2em",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          Welcome, {props.userStore.userProfile?.fname}!
        </h4>
        {/* Showing Online and Offline is not required as of now(Ms.Amruta) */}
        {/* {getConnectionData(
          props.globalStore.speedData !== undefined
            ? props.globalStore.speedData.downlink
            : ""
        )} */}
        {/* </IconButton> */}
        {/* </Hidden> */}
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
  onSidebarMini: PropTypes.func,
};

function mapStateToProps(store) {
  return {
    globalStore: store.globalStore,
    patientStore: store.patientStore,
    processCount: Number(store.userStore.processCount),
    userStore: store.userStore,
    entitlementStore: store.entitlementStore,
    isViewPatientsBuActive:
      store.globalStore?.orgzFeatures?.view_patients_from_bulk_upload,
    isBulkUploadForPatientActive:
      store.globalStore?.orgzFeatures?.bulk_upload_for_patient,
    currentUserOrgzBalanceAmount:
      store.userStore?.imageProcessAndBalanceAmount?.balance_amount,
    lastRechargedPrice:
      store.userStore?.imageProcessAndBalanceAmount?.last_recharged_price,
  };
}
export default connect(mapStateToProps, {
  getNetSpeed,
  getuserDetailNew,
  syncPatientDataWithServer,
  updateOrgCountsAndBalances,
})(withRouter(Topbar));
